module.exports = __webpack_public_path__ + "assets/62a1e12af6a211cbf6f0a2bbca07970c.png";